import GrandResortLogo from 'public/images/grandresort.svg';

/**
 * TT-713: Im R1-Layout besteht der Header nur noch aus einem weissen Balken
 * mit dem Grand-Resort-Logo. Navigation, Suche, Warenkorb-Icon, Sprachwechsel
 * und das Tamina-Therme-Signet sind bewusst nicht mehr enthalten.
 *
 * Masse gemäss Konzept: Balken 74px, Logo 42px, padding-left max. 32px.
 */
export default function Header({ menus }) {
  return (
    <header className="flex h-[74px] items-center bg-white px-4 md:px-8">
      <GrandResortLogo className="h-[42px] w-auto text-black" />
    </header>
  );
}
